import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import DataTable from '../../components/Table/DataTable';
import SearchBox from '../../components/SearchBox/SearchBox';

import { showAlert } from '../../store/ducks/alert';
import { getSSLs, getSSLsBySearch } from '../../services/ssl';
import { CircularProgress } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

const SSLs = ({ location, match }) => {
    const dispatch = useDispatch();
    const [ssls, setSSLs] = useState([]);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isSearching, setIsSearching] = useState(false);
    const [searchField, setSearchField] = useState({
        searchItem: '',
        search: '',
    });

    useEffect(() => {
        if (location.state && location.state.remount) {
            handleSubmitSearch({
                searchItem: '',
                search: '',
            });
        }
    }, [location]);

    useEffect(() => {
        if (match && match.params.searchItem && match.params.search) {
            handleSubmitSearch({
                searchItem: match.params.searchItem,
                search: match.params.search,
            });
        }
        displaySSls();
    }, [isSearching, page]);

    useEffect(() => {
        document.addEventListener('keydown', escape, false);

        return () => {
            document.removeEventListener('keydown', escape, false);
        };
    }, []);

    const escape = useCallback(event => {
        if (event.keyCode === 27) {
            handleSubmitSearch({
                searchItem: '',
                search: '',
            });
            window.history.pushState({ searching: true }, 'Searching', '/' + window.location.href.split('/')[3]);
        }
    }, []);

    const handleSubmitSearch = searchBox => {
        setSearchField({
            ...searchField,
            searchItem: searchBox.searchItem,
            search: searchBox.search,
        });
        setIsSearching(searchBox.search);
    };

    const headers = ['id', 'customDomainId', 'arn', 'status', 'expirateDate'];

    const displaySSls = async () => {
        try {
            setIsLoading(true);
            let sslAux;

            if (isSearching) {
                const { data } = await getSSLsBySearch(searchField.searchItem, searchField.search);
                sslAux = data;
            } else if (!isSearching && Object.keys(match.params).length === 0) {
                const { data } = await getSSLs(page);
                sslAux = data;
            }
            if (!sslAux) return;

            setSSLs(sslAux.rows);
            setTotalItems(sslAux.count);
            setTotalPages(sslAux.pages);
            setPage(sslAux.page);
            setIsLoading(false);
        } catch (error) {
            dispatch(showAlert('error', error.message));
        }
    };

    if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

    return (
        <>
            <div className="channels-container">
                <h1>SSLs ({totalItems})</h1>

                <SearchBox selectItems={['id', 'customDomainId', 'arn', 'status']} onSubmitSearch={handleSubmitSearch} isSearching={isSearching} onKeyDown={escape} />
            </div>

            <DataTable
                head={headers}
                body={ssls}
                action={true}
                bodyColumn={headers}
                linkPath="ssl"
                totalPages={totalPages}
                currentPage={page}
                setPageChange={setPage}
            />
        </>
    );
};

export default SSLs;
